import axios from "axios";
import APIs from "../components/APIInit";
import store from "@/store";
//import jQuery from "jquery";
//let $ = jQuery;

var vm;
export default {
    methods: {
        InitAnalytics: function() {
            vm = this;
            document.addEventListener('click', function(e) {
                if (e && e.target) {
                    if (e.target.hasAttribute('data-analytics')) {
                        var pageName = location.pathname;
                        var action = "";
                        var actionType = "";
                        var actionLabel = "";
                        if (e.target.hasAttribute('data-page-name')) {
                            pageName = e.target.getAttribute('data-page-name');
                        }
                        if (e.target.hasAttribute('data-action')) {
                            action = e.target.getAttribute('data-action');
                        }
                        if (e.target.hasAttribute('data-action-type')) {
                            actionType = e.target.getAttribute('data-action-type');
                        }
                        if (!actionType) {
                            if (e.target.tagName) {
                                actionType = e.target.tagName.toLowerCase();
                            }
                        }
                        if (e.target.hasAttribute('data-action-label')) {
                            actionLabel = e.target.getAttribute('data-action-label');
                        }
                        if (!actionLabel) {
                            if (e.target.hasAttribute('data-tag')) {
                                actionLabel = e.target.getAttribute('data-tag');
                            }
                        }
                        //alert("add analytics");

                        //alert("pageName:" + pageName);
                        //alert("action:" + action);
                        //alert("actionType:" + actionType);
                        //alert("actionLabel:" + actionLabel);
                        if (pageName) {
                            //alert("add analytics");
                            vm.AddEventAnalytics({ pageName: pageName, action: action, actionType: actionType, actionLabel: actionLabel });
                        }
                    }
                }
            }, false);
        },
        hasClass: function(e, className) {
            return e.classList.contains(className);
        },
        AddEventAnalytics: function(data) {
            try {
                var clientId = "";
                var client = store.getters.getClient;
                if (client && client.length > 0) {
                    clientId = client[0].id;
                }
                var eventId = store.getters.getEvent;
                var eventName = store.getters.getEventName;
                var uid = "";
                var name = "";
                var email = "";
                var user = store.getters.getUser;
                if (user) {
                    uid = user.id;
                    name = user.name;
                    email = user.Email;
                }
                if(email == "visitor@e2m.live"){
                    return;
                }
                data.pageName = data.pageName ? data.pageName : location.pathname;
                data.action = data.action ? data.action : "";
                data.actiontype = data.actiontype ? data.actiontype : "";
                data.actionLabel = data.pageName ? data.actionLabel : "";
                var postData = {
                    instanceId: "OA_UAT",
                    clientId: clientId,
                    eventId: eventId,
                    origin: "Responsive",
                    eventName: eventName,
                    userId: uid,
                    userName: name,
                    userEmail: email,
                    pageName: data.pageName,
                    action: data.action,
                    actionType: data.actiontype,
                    actionLabel: data.actionLabel,
                };

                let headers = {
                    "Content-Type": "application/json",
                };
                axios
                    .post(
                        APIs.AnalyticsUserAction,
                        postData, {
                            headers: headers,
                        }
                    )
                    .then((data) => {
                        console.log(data);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } catch (err) {
                console.log(err.message);
            }
        },
    }
}